<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="searchMaterial" class="form-inline my-2 my-lg-0">
<!--                    <input-->
<!--                        class="form-control mr-sm-2"-->
<!--                        type="search"-->
<!--                        placeholder="รหัสวัตถุดิบ"-->
<!--                        aria-label="Search"-->
<!--                        v-model="search.code"/>-->
                    <multiselect
                        class="form-control border-0"
                        v-model="search.code_list"
                        :options="filter_option"
                        track-by="id"
                        multiple
                        :customLabel="codeLabel"
                        :show-labels="false"
                        placeholder="รหัสวัตถุดิบ">
                    </multiselect>
                    &nbsp;
                    <b-form-select v-model="search.type"
                                   @input="listType(search.type)"
                                   :options="material_type">
                    </b-form-select>
                    &nbsp;
                    <multiselect
                        v-if="search.type == 2"
                        v-model="search.type_bag"
                        :show-labels="false"
                        :options="optionBagType"
                        label="name"
                        multiple=""
                        class="w-25"
                        placeholder="ประเภทถุง"
                        track-by="name">
                    </multiselect>
                    &nbsp;
                    <select class="form-control" v-model="search.active">
                        <option
                            v-for="options in optionActive"
                            :value="options.value">{{ options.text }}</option>
                    </select>
                    &nbsp;
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchMaterial">
                        <icon name="search"></icon> ค้นหา
                    </button>
                    &nbsp;&nbsp;
                    <router-link to="materials-information">
                        <template v-if="canInventoryMaterialsUpdate">
                            <button
                                    class="btn btn-warning my-2 my-sm-0"
                                    type="button">
                                <icon name="plus"></icon>
                                เพิ่มวัตถุดิบ
                            </button>
                        </template>
                    </router-link>
                    &nbsp;
                    <button class="btn btn-primary"
                            @click="showPrintMaterialReport"
                            type="button">
                        <icon name="print"></icon>
                        รายงานการสั่งซื้อ
                    </button>
                </form>
            </div>
        </nav>
        <span style="color: red; font-size: 15px;padding-left: 15px">สามารถกดสั่งซื้อได้เฉพาะ คุณมด,เฮีย,คุณนิคมเท่านั้น</span>
        <div class="col-12 table-responsive" >
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">สถานะยกเลิก</th>
                    <th scope="col">สั่งซื้อวัตถุดิบ</th>
                    <th scope="col">สถานะการสั่งซื้อ</th>
                    <th scope="col">นำเข้าวัตถุดิบ</th>
                    <th scope="col">เบิกวัตถุดิบ</th>
                    <th scope="col">รหัสวัตถุดิบ</th>
                    <th scope="col">ประเภทถุง</th>
                    <th scope="col">รายการ</th>
                    <th scope="col">จำนวนคงเหลือ</th>
                    <th scope="col">ผู้ทำรายการล่าสุด</th>
                    <th scope="col">วันที่อัพเดตล่าสุด</th>
                    <template v-if="canInventoryMaterialsUpdate">
                        <th scope="col">แก้ไข</th>
                    </template>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in material">
                    <td>
                        <template v-if="data.cancel_status">
                            <span style="color:red">InActive</span>
                        </template>
                        <template v-else>
                            <span style="color:green">Active</span>
                        </template>
                    </td>
                    <td>
                        <template v-if="canViewSuperAdmin || user.id==3 || user.username == 50010 || user.username == 10070 || user.username == 10388 || user.username == 10389">
                            <a v-if="data.quantity < data.min_quantity"
                               @click="showPreOrderMaterailsModal(data.id)">
                                <img src="@/assets/shopping-basket.png" width="40px"/>
                            </a>
                            <div v-else
                                 @click="showPreOrderMaterailsModal(data.id)"
                                style="cursor: pointer">
                                <img src="@/assets/shopping-basket_green.png" width="40px"/>
                            </div>
                        </template>
                        <template v-else>
                            <a v-if="data.quantity < data.min_quantity" style="cursor: not-allowed">
                                <img src="@/assets/shopping-basket.png" width="40px"/>
                            </a>
                            <div v-else>
                                <img src="@/assets/shopping-basket_green.png" width="40px" style="cursor: not-allowed"/>
                            </div>
                        </template>
                    </td>
                    <td>
                        {{data.preOrder_status_name}}
                    </td>
                    <td>
                        <template>
                            <a @click="showMaterialImportModal(data.id)">
                                <img src="@/assets/plus_icon.png" width="40px"/>
                            </a>
                        </template>
                    </td>
                    <td>
                        <a @click="showMaterialExportModal(data.id)">
                            <img src="@/assets/delete_icon.png" width="40px"/>
                        </a>
                    </td>
                    <td>{{ data.code }}</td>
                    <td>{{ data.type_bag?data.type_bag.name:'' }}</td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.quantity | currency }} {{data.type_unit}}</td>
                    <td>{{data.user?data.user.name:''}}</td>
                    <td>{{ data.updated_at | moment("DD/MM/YYYY , H:mm:ss") }}</td>
                    <template v-if="canInventoryMaterialsUpdate">
                        <td>
                            <a @click="goToMaterialInformation(data.id)">
                                <icon name="pencil-alt"></icon>
                            </a>
                            &nbsp;&nbsp;
                        </td>
                    </template>
                </tr>
                </tbody>
            </table>
        </div>
        <!--paginate-->
        <div v-if="material.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getMaterialPage">
            </vue-pagination>
        </div>
        <!--
            -------------------Modal Pre Order--------------------------------
        -->
        <b-modal
                hide-footer
                ref="pre_order"
                id="preOrder"
                title="สั่งซื้อวัตถุดิบ">
            <pre-order-materials @submit="saveMaterialToPreOrder">
            </pre-order-materials>
        </b-modal>
        <!--
            -------------------Modal Import Data--------------------------------
        -->
        <b-modal
            hide-footer
            ref="import_data"
            id="import"
            title="เพิ่มวัตถุดิบเข้าคลัง">
            <import-material-modal @submit="saveMaterialImport">
            </import-material-modal>
        </b-modal>
        <!--
            -------------------Modal export Data--------------------------------
        -->
        <b-modal
            hide-footer
            ref="export_data"
            id="export"
            title="เบิกวัตถุดิบ">
            <export-material-modal
                    @submit="saveMaterialExport">
            </export-material-modal>
        </b-modal>

        <!--
            -------------------Modal print report material--------------------------------
        -->
        <b-modal
                hide-footer
                ref="print_report_material"
                id="export"
                title="รายงานการสั่งซื้อวัตถุดิบ">
            <material-print-report @submit="printMaterialReport">
            </material-print-report>
        </b-modal>
        <br />
    </div>
</template>

<script>
import {mapState} from "vuex";
import ExportMaterialModal from "../Export/ExportMaterialModal";
import ImportMaterialModal from "../Import/ImportMaterialModal";
import VuePagination from "../../Pagination";
import {domain} from "../../../util/Constants";

import {
    canInventoryMaterialsExport,
    canInventoryMaterialsImport,
    canInventoryMaterialsUpdate,
    canInventoryMaterialsView,
    canInventoryProductsView,
    canViewSuperAdmin,
} from "../../../util/Permissions";
import PreOrderMaterials from "../Import/PreOrderMaterials";
import MaterialPrintReport from "./MaterialPrintReport";
import {Multiselect} from "vue-multiselect";

export default {
    components: {
        MaterialPrintReport,
        PreOrderMaterials,
        VuePagination,
        ImportMaterialModal,
        ExportMaterialModal,
        Multiselect
    },
    name: "materials",
    data() {
        return {
            material : [],
            dataPaginate : {
                current_page : 1,
                from : 1,
                last_page : 1,
                per_page : 1,
                total : 1,
                to : 1
            },
            id: "",
            event_submit : false,
            material_code : [],
            search:{
                code : "",
                type : "",
                code_list : "",
                active : '1',
                type_bag : [],
                type_bag_id : ''
            },
            optionActive : [
                {text:'แสดงทั้งหมด',value:'all'},
                {text:'Active',value:'1'},
                {text:'InActive',value:'0'},
            ],
            filter_option : [],
        };
    },
    created() {
        this.$store.dispatch("Common/getMaterialType");
        this.$store.dispatch("Common/getMaterialCode").then(res=>{
            this.material_code = res;
            this.filter_option = res;
        });
        // this.$store.dispatch("Products/clearSearch");
        this.getMaterialPage();
    },
    computed: {
        canInventoryMaterialsView,
        canInventoryMaterialsImport,
        canInventoryMaterialsExport,
        canInventoryMaterialsUpdate,
        canInventoryProductsView,
        canViewSuperAdmin,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            optionBagType:state=>{
                return state.BagData.bag_type
            },
            // search:state =>{
            //     return state.Material.search;
            // },
            material_type : state=>{
                return [
                    {
                        value : "",
                        text : "เลือกประเภทวัตถุดิบ"
                    },
                    ...state.Common.material_type.map(type=>({
                        value: type.id,
                        text: type.name
                    }))
                ]
            }
        })
    },
    methods: {
        listType(cur){
            this.filter_option = this.material_code;
            this.filter_option = this.filter_option.filter(x=>x.type == cur)
            this.search.code_list = '';
        },
        codeLabel(option){
            return `${option.code}`
        },
        //Modal
        showMaterialImportModal(id) {
            this.id = id;
            this.showMaterialData(this.id);
            this.$refs.import_data.show();
        },
        hideMaterialImportModal() {
            this.$refs.import_data.hide();
        },
        showMaterialExportModal(id) {
            this.id = id;
            this.showMaterialData(this.id);
            this.$refs.export_data.show();
        },
        hideMaterialExportModal() {
            this.$refs.export_data.hide();
        },
        showPreOrderMaterailsModal(id) {
            this.id = id;
            this.showMaterialData(this.id);
            this.$refs.pre_order.show();
        },
        hidePreOrderMaterailsModal() {
            this.$refs.pre_order.hide();
        },
        showPrintMaterialReport() {
            this.$refs.print_report_material.show();
        },
        hidePrintMaterialReport() {
            this.$refs.print_report_material.hide();
        },
        //API
        saveMaterialToPreOrder(submitData) {
            if(submitData!=0){
                submitData.quantity = parseInt(submitData.quantity);
                this.$store.dispatch('PreOrder/create',submitData).then(()=>{
                    this.hidePreOrderMaterailsModal();
                    this.getMaterialPage();
                })
            }
            this.hidePreOrderMaterailsModal();
        },
        saveMaterialImport(submitData){
            if(submitData != 0){
                this.$store.dispatch("ImportMaterial/create",submitData).then(()=>{
                    this.$router.push("/materials-import")
                })
            }
            this.hideMaterialImportModal();
        },
        saveMaterialExport(submitData) {
            if(submitData!=="cancel"){
                this.$store
                    .dispatch("ExportMaterial/create", submitData)
                    .then(data => {
                        if(!data){
                            alert("กรุณาใส่หมายเหตุไม่เกิน 255 ตัวอักษร")
                        }
                        else{
                            this.$router.push({
                                name: "materials-export"
                            });
                            this.hideMaterialExportModal();
                        }
                    });
            }
            this.hideMaterialExportModal();
        },
        showMaterialData(id) {
            this.$store.dispatch("Material/show", id);
        },
        searchMaterial() {
            this.event_submit = true;
            if (this.search.code_list.length > 0){
                let code = '';
                this.search.code_list.forEach((x,i)=>{
                    if (i>0)code += ','+x.id;
                    else code += x.id;
                })
                this.search.code = code;
            }else{
                this.search.code = '';
            }
            if (this.search.type_bag.length > 0){
                let type_bag = '';
                this.search.type_bag.forEach((x,i)=>{
                    if (i>0)type_bag += ','+x.id;
                    else type_bag += x.id;
                })
                this.search.type_bag_id = type_bag;
            }else{
                this.search.type_bag_id = '';
            }
            this.$store.dispatch("Material/search", {
                page : 1,
                data : this.search
            }).then(res=>{
                this.material = res.data;
                this.dataPaginate = {
                    current_page : res.current_page,
                    from : res.form,
                    last_page : res.last_page,
                    per_page : res.per_page,
                    total : res.total,
                    to : res.to
                }
            });
        },
        //function
        goToMaterialInformation(id) {
            this.$router.push({
                name: "materials-information",
                params: { id }
            });
        },
        getMaterialPage(){
            const page = this.dataPaginate.current_page;
            // if(this.event_submit){
                if (this.search.code_list.length > 0){
                    let code = '';
                    this.search.code_list.forEach((x,i)=>{
                        if (i>0)code += ','+x.id;
                        else code += x.id;
                    })
                    this.search.code = code;
                }else{
                    this.search.code = '';
                }
                if (this.search.type_bag.length > 0){
                    let type_bag = '';
                    this.search.type_bag.forEach((x,i)=>{
                        if (i>0)type_bag += ','+x.id;
                        else type_bag += x.id;
                    })
                    this.search.type_bag_id = type_bag;
                }else{
                    this.search.type_bag_id = '';
                }
                this.$store.dispatch("Material/search", {
                    page : page,
                    data : this.search
                }).then(res=>{
                    this.material = res.data;
                    this.dataPaginate = {
                        current_page : res.current_page,
                        from : res.form,
                        last_page : res.last_page,
                        per_page : res.per_page,
                        total : res.total,
                        to : res.to
                    }
                });
            // }else{
            //     this.$store.dispatch("Material/get",page).then(res=>{
            //         this.material = res.data;
            //         this.dataPaginate = {
            //             current_page : res.current_page,
            //             from : res.form,
            //             last_page : res.last_page,
            //             per_page : res.per_page,
            //             total : res.total,
            //             to : res.to
            //         }
            //     });
            // }
        },
        printMaterialReport(value){
            if(value){
                window.open(domain+"/material_report?type="+value.type+
                "&start_date="+value.start_date+
                "&end_date="+value.end_date+"&vendor_id="+value.vendor_id,'_blank');
            }
            this.hidePrintMaterialReport();
        }
    }
};
</script>

<style lang="scss" scoped>
    a{
        cursor: pointer;
    }
</style>
